import styled from 'styled-components';

export const ScConfirmRemoveMethodModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  & > .content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    text-align: center;

    & > h3 {
      font-size: 22px;
      font-weight: 700;
      line-height: 28px;
      letter-spacing: 0.22px;
      color: ${({ theme }) => theme.whiteColor};
      text-transform: capitalize;
    }

    & > p {
      font-size: 16px;
      font-weight: 700;
      line-height: 28px;
      letter-spacing: 0.16px;
    }
  }

  & > footer {
    display: flex;
    gap: 8px;
  }
`;
